import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    Box,
    Typography,
    Grid,
    Card,
    CardMedia,
    CircularProgress,
    Container,
} from "@mui/material";

function AboutUs() {
    const [aboutus, setAboutus] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios
            .get("/files/corporate/about.txt")
            .then((res) => {
                const content = Array.isArray(res.data)
                    ? res.data
                    : [res.data];
                setAboutus(content);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, []);

    return (
        <Container maxWidth="lg" sx={{ py: 2 }}>
            <Typography
                variant="h3"
                align="center"
                gutterBottom
                sx={{
                    fontWeight: "bold",
                    color: "#030366",
                    mt: 7,
                    fontSize: {
                        xs: "1.8rem",  // mobile (~h4)
                        sm: "2.2rem",  // tablet (~h3)
                        md: "2.8rem",  // laptop (~h3+)
                        lg: "3rem",    // desktop (~h2)
                    },
                }}
            >
                About Us
            </Typography>

            {loading ? (
                <Box display="flex" justifyContent="center" mt={5}>
                    <CircularProgress />
                </Box>
            ) : (
                <Grid
                    container
                    spacing={3}
                    alignItems="center"
                    justifyContent="space-evenly"
                    sx={{
                        flexDirection: {
                            xs: "column", // mobile
                            sm: "column", // tablet
                            md: "row",    // laptop and above
                        },
                    }}
                >
                    {/* --- Text Section --- */}
                    <Grid
                        item
                        xs={12}
                        md={6}
                        sx={{
                            width: {
                                xs: "100%",
                                sm: "100%",
                                md: "60%",
                            },
                            px: { xs: 1, sm: 2, md: 0 },
                        }}
                    >
                        {aboutus.map((paragraph, index) => (
                            <Typography
                                key={index}
                                variant="body1"
                                paragraph
                                sx={{
                                    fontFamily: "Raleway, sans-serif",
                                    lineHeight: 1.8,
                                    mb: 2,
                                    textAlign: "justify",
                                    fontSize: {
                                        xs: "0.95rem",
                                        sm: "1rem",
                                        md: "1.05rem",
                                    },
                                }}
                            >
                                {paragraph}
                            </Typography>
                        ))}
                    </Grid>

                    {/* --- Image Section --- */}
                    <Grid
                        item
                        xs={12}
                        md={5}
                        sx={{
                            width: {
                                xs: "100%",
                                sm: "100%",
                                md: "30%",
                            },
                            display: "flex",
                            justifyContent: {
                                xs: "center",
                                sm: "center",
                                md: "flex-start",
                            },
                        }}
                    >
                        <Card
                            sx={{
                                borderRadius: 3,
                                overflow: "hidden",
                                boxShadow: 3,
                                width: {
                                    xs: "100%",
                                    sm: "100%",
                                    md: "100%",
                                },
                                maxWidth: { md: 400 },
                            }}
                        >
                            <CardMedia
                                component="img"
                                alt="About Us"
                                image="/images/about1.jpg"
                                sx={{
                                    height: {
                                        xs: 250,
                                        sm: 300,
                                        md: 400,
                                    },
                                    width: "100%",
                                    objectFit: "cover",
                                }}
                            />
                        </Card>
                    </Grid>
                </Grid>
            )}
        </Container>
    );
}

export default AboutUs;





// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import {
//     Box,
//     Typography,
//     Grid,
//     Card,
//     CardContent,
//     CardMedia,
//     CircularProgress,
//     Container,
// } from "@mui/material";

// function AboutUs() {
//     const [aboutus, setAboutus] = useState(null);
//     const [loading, setLoading] = useState(true);

//     useEffect(() => {
//         axios
//             .get("/files/corporate/about.txt")
//             .then((res) => {
//                 const content = Array.isArray(res.data)
//                     ? res.data
//                     : [res.data];
//                 setAboutus(content);
//                 setLoading(false);
//             })
//             .catch(() => setLoading(false));
//     }, []);

//     return (
//         <Container maxWidth="lg" sx={{ py: 2 }}>
//             <Typography
//                 variant="h3"
//                 align="center"
//                 gutterBottom
//                 sx={{ fontWeight: "bold", color: "#030366", mt: 7 }}
//             >
//                 About Us
//             </Typography>

//             {loading ? (
//                 <Box display="flex" justifyContent="center" mt={5}>
//                     <CircularProgress />
//                 </Box>
//             ) : (
//                 <Grid container spacing={2} alignItems="center" sx={{ display: "flex", flexDirection: "row", justifyContent: "space-evenly", alignItems: "flex-start" }}>
//                     <Grid item xs={12} md={4} sx={{ width: "60%" }}>
//                         {aboutus.map((paragraph, index) => (
//                             <Typography
//                                 key={index}
//                                 variant="body1"
//                                 paragraph
//                                 sx={{
//                                     fontFamily: "Raleway, sans-serif",
//                                     lineHeight: 1.8,
//                                     mb: 2,
//                                     textAlign: "justify"
//                                 }}
//                             >
//                                 {paragraph}
//                             </Typography>
//                         ))}
//                     </Grid>

//                     <Grid item xs={12} md={4} sx={{ width: "30%" }}>
//                         <Card
//                             sx={{
//                                 borderRadius: 3,
//                                 overflow: "hidden",
//                                 boxShadow: 3,
//                             }}
//                         >
//                             <CardMedia
//                                 component="img"
//                                 alt="About Us"
//                                 height="400"
//                                 image="/images/about1.jpg"
//                             />
//                         </Card>
//                     </Grid>
//                 </Grid>
//             )}
//         </Container>
//     );
// }

// export default AboutUs;
